export default defineNuxtRouteMiddleware(() => {
  const user = useSupabaseUser()
  // debugger
  const meta = (user.value as any)?.app_metadata
  if (!user.value || meta?.role !== 'admin') {
    return navigateTo('/')
  }
})
